var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.showUpdateNotification ? _c('v-card', {
    staticClass: "update-notification-card",
    attrs: {
      "elevation": "4",
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "size": "32"
    }
  }, [_vm._v("mdi-update")]), _c('div', {
    staticClass: "flex-grow-1"
  }, [_c('div', {
    staticClass: "update-title"
  }, [_vm._v("New Version Available")]), _c('div', {
    staticClass: "update-subtitle"
  }, [_vm._v(" " + _vm._s(_vm.countdown > 0 ? `Updating in ${_vm.countdown} second${_vm.countdown !== 1 ? 's' : ''}...` : 'Updating now...') + " ")])]), _vm.countdown > 0 ? _c('v-progress-circular', {
    staticClass: "ml-3",
    attrs: {
      "value": _vm.countdown / _vm.initialCountdown * 100,
      "size": "32",
      "width": "3"
    }
  }) : _vm._e()], 1)])], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }